// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Products Page Glass Styles
   ========================================== */

.products-page {
  font-family: var(--font-family);
  color: var(--text-muted);
  line-height: 1.6;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* Hero Section */
.products-hero-section {
  background: radial-gradient(circle at 50% 20%, rgba(245, 158, 11, 0.12) 0%, rgba(15, 23, 42, 0) 75%);
  border: none !important;
  border-radius: 0 !important;
  padding: 3.5rem 2rem 2.5rem 2rem;
  position: relative;
  overflow: hidden;
  margin-top: 5.5rem !important;
  margin-bottom: 2rem;
  box-shadow: none !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  width: 100% !important;
}

.products-hero-overlay {
  position: relative;
  z-index: 1;
  text-align: center !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
}

.products-hero-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  width: 100% !important;
  max-width: 900px !important;
  margin: 0 auto !important;
}

.products-hero-title {
  font-size: clamp(2.2rem, 4.5vw, 3.5rem) !important;
  font-weight: 800 !important;
  margin: 0 auto 1.25rem auto !important;
  color: #ffffff !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem;
  letter-spacing: -0.02em;
  line-height: 1.2;
  text-align: center !important;
  width: 100% !important;
}

.product-subtitle {
  font-size: clamp(1.2rem, 2.5vw, 1.6rem);
  font-weight: 600;
  color: var(--color-amber);
  margin: 0.35rem auto 0 auto !important;
  position: relative;
  display: block !important;
  text-align: center !important;
}

.products-hero-subtitle {
  font-size: 1.05rem !important;
  max-width: 750px !important;
  margin: 0 auto 2rem auto !important;
  color: #cbd5e1 !important;
  line-height: 1.6;
  text-align: center !important;
}

.hero-subtitle strong {
  color: #ffffff;
  background: rgba(245, 158, 11, 0.12);
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  border: 1px solid rgba(245, 158, 11, 0.25);
}

.products-hero-cta-group {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 1rem !important;
  flex-wrap: wrap !important;
  width: 100% !important;
  margin: 0 auto !important;
}

.btn-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--grad-primary);
  color: #0F172A;
  padding: 0.85rem 1.75rem;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 800;
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);
  white-space: nowrap;
  border: none;
  cursor: pointer;
}

.btn-hero:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.5);
}

.btn-hero-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 0.85rem 1.75rem;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.btn-hero-secondary:hover {
  background: rgba(51, 65, 85, 0.9);
  border-color: rgba(245, 158, 11, 0.5);
  color: var(--color-amber);
  transform: translateY(-2px);
}

/* Statistics Section */
.stats-section {
  padding: 2.5rem 0 3.5rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
  text-align: center;
}

@media (max-width: 900px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  padding: 1.75rem 1.25rem;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 16px;
  transition: all 0.25s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.stat-card:hover {
  transform: translateY(-3px);
  border-color: rgba(245, 158, 11, 0.5);
  background: rgba(20, 28, 48, 0.85);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35), 0 0 15px rgba(245, 158, 11, 0.12);
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--color-amber);
  margin-bottom: 0.25rem;
  line-height: 1;
}

.stat-label {
  color: #94a3b8;
  font-size: 0.88rem;
  font-weight: 600;
  margin: 0;
}

/* Products Section */
.products-section {
  padding: 3rem 0 4rem;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
}

.section-subtitle {
  font-size: 1.02rem;
  color: #94a3b8;
  max-width: 650px;
  margin: 0 auto;
  line-height: 1.55;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.75rem;
}

@media (max-width: 850px) {
  .products-grid {
    grid-template-columns: 1fr;
  }
}

.product-card {
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(16px);
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(245, 158, 11, 0.22);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
}

.product-card:hover {
  transform: translateY(-4px);
  border-color: rgba(245, 158, 11, 0.5);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(245, 158, 11, 0.15);
}

.product-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.product-name {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.35rem;
  line-height: 1.3;
}

.product-description {
  color: #cbd5e1;
  font-size: 0.92rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.detail-section {
  background: rgba(30, 41, 59, 0.5);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.75rem;
  border: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: auto;
}

.detail-section h4 {
  color: #ffffff;
  font-size: 0.88rem;
  margin-bottom: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.detail-section ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.detail-section li {
  color: #94a3b8;
  padding: 0.3rem 0 0.3rem 1.5rem;
  position: relative;
  font-size: 0.88rem;
  line-height: 1.45;
}

.detail-section li:before {
  content: "\\2713";
  position: absolute;
  left: 0;
  color: var(--color-amber);
  font-weight: bold;
}

.btn-apply {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  text-align: center;
  background: var(--grad-primary);
  color: #0F172A;
  padding: 0.8rem 1.25rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 800;
  font-size: 0.92rem;
  transition: all 0.25s ease;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.btn-apply:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}

/* Process Section */
.process-section {
  padding: 3rem 0 4rem;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
}

@media (max-width: 900px) {
  .process-steps {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 550px) {
  .process-steps {
    grid-template-columns: 1fr;
  }
}

.process-step {
  text-align: center;
  padding: 2rem 1.25rem;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  transition: transform 0.25s ease, border-color 0.25s ease;
}

.process-step:hover {
  transform: translateY(-3px);
  border-color: rgba(245, 158, 11, 0.4);
}

.step-icon {
  font-size: 2.2rem;
  margin-bottom: 0.75rem;
  line-height: 1;
}

.step-number {
  font-size: 0.75rem;
  color: var(--color-amber);
  font-weight: 800;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.step-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #ffffff;
}

.step-description {
  color: #94a3b8;
  font-size: 0.88rem;
  line-height: 1.5;
  margin: 0;
}

/* CTA Section */
.cta-section {
  padding: 4rem 2rem;
  background: radial-gradient(circle at 50% 30%, rgba(245, 158, 11, 0.16) 0%, rgba(15, 23, 42, 0.96) 75%);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 24px;
  text-align: center;
  margin-bottom: 4rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
}

.cta-title {
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  font-weight: 800;
  margin-bottom: 0.85rem;
  color: #ffffff;
  letter-spacing: -0.02em;
}

.cta-subtitle {
  font-size: 1.02rem;
  max-width: 650px;
  margin: 0 auto 2rem;
  color: #cbd5e1;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-cta-primary {
  background: var(--grad-primary);
  color: #0F172A;
  padding: 0.85rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 800;
  font-size: 0.95rem;
  transition: all 0.25s ease;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);
}

.btn-cta-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.5);
}

.kubersetu-badge {
  display: inline-block;
  background: transparent;
  color: var(--color-amber);
  padding: 0.2rem 0;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  margin-bottom: 1.25rem;
  text-transform: uppercase;
  border: none;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 3rem 1.25rem;
    margin-top: 4rem;
  }
  .cta-section {
    padding: 2.5rem 1.25rem;
  }
  .btn-cta-primary {
    width: 100%;
  }
  .hero-cta-group {
    flex-direction: column;
    width: 100%;
  }
  .btn-hero,
  .btn-hero-secondary {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Products.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,oGAAoG;EACpG,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;EAC3B,sCAAsC;EACtC,yBAAyB;EACzB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,uGAAuG;EACvG,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Products Page Glass Styles\n   ========================================== */\n\n.products-page {\n  font-family: var(--font-family);\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n/* Hero Section */\n.products-hero-section {\n  background: radial-gradient(circle at 50% 20%, rgba(245, 158, 11, 0.12) 0%, rgba(15, 23, 42, 0) 75%);\n  border: none !important;\n  border-radius: 0 !important;\n  padding: 3.5rem 2rem 2.5rem 2rem;\n  position: relative;\n  overflow: hidden;\n  margin-top: 5.5rem !important;\n  margin-bottom: 2rem;\n  box-shadow: none !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-align: center !important;\n  width: 100% !important;\n}\n\n.products-hero-overlay {\n  position: relative;\n  z-index: 1;\n  text-align: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100% !important;\n}\n\n.products-hero-container {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-align: center !important;\n  width: 100% !important;\n  max-width: 900px !important;\n  margin: 0 auto !important;\n}\n\n.products-hero-title {\n  font-size: clamp(2.2rem, 4.5vw, 3.5rem) !important;\n  font-weight: 800 !important;\n  margin: 0 auto 1.25rem auto !important;\n  color: #ffffff !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 0.5rem;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  text-align: center !important;\n  width: 100% !important;\n}\n\n.product-subtitle {\n  font-size: clamp(1.2rem, 2.5vw, 1.6rem);\n  font-weight: 600;\n  color: var(--color-amber);\n  margin: 0.35rem auto 0 auto !important;\n  position: relative;\n  display: block !important;\n  text-align: center !important;\n}\n\n.products-hero-subtitle {\n  font-size: 1.05rem !important;\n  max-width: 750px !important;\n  margin: 0 auto 2rem auto !important;\n  color: #cbd5e1 !important;\n  line-height: 1.6;\n  text-align: center !important;\n}\n\n.hero-subtitle strong {\n  color: #ffffff;\n  background: rgba(245, 158, 11, 0.12);\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n  border: 1px solid rgba(245, 158, 11, 0.25);\n}\n\n.products-hero-cta-group {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 1rem !important;\n  flex-wrap: wrap !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n}\n\n.btn-hero {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: var(--grad-primary);\n  color: #0F172A;\n  padding: 0.85rem 1.75rem;\n  border-radius: 50px;\n  font-size: 0.95rem;\n  font-weight: 800;\n  text-decoration: none;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);\n  white-space: nowrap;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-hero:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.5);\n}\n\n.btn-hero-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: rgba(30, 41, 59, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  padding: 0.85rem 1.75rem;\n  border-radius: 50px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-decoration: none;\n  transition: all 0.25s ease;\n  white-space: nowrap;\n}\n\n.btn-hero-secondary:hover {\n  background: rgba(51, 65, 85, 0.9);\n  border-color: rgba(245, 158, 11, 0.5);\n  color: var(--color-amber);\n  transform: translateY(-2px);\n}\n\n/* Statistics Section */\n.stats-section {\n  padding: 2.5rem 0 3.5rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.25rem;\n  text-align: center;\n}\n\n@media (max-width: 900px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 500px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.stat-card {\n  padding: 1.75rem 1.25rem;\n  background: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 16px;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.stat-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(245, 158, 11, 0.5);\n  background: rgba(20, 28, 48, 0.85);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35), 0 0 15px rgba(245, 158, 11, 0.12);\n}\n\n.stat-number {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: var(--color-amber);\n  margin-bottom: 0.25rem;\n  line-height: 1;\n}\n\n.stat-label {\n  color: #94a3b8;\n  font-size: 0.88rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Products Section */\n.products-section {\n  padding: 3rem 0 4rem;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.section-title {\n  font-size: clamp(1.8rem, 3.5vw, 2.5rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n  letter-spacing: -0.02em;\n}\n\n.section-subtitle {\n  font-size: 1.02rem;\n  color: #94a3b8;\n  max-width: 650px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.75rem;\n}\n\n@media (max-width: 850px) {\n  .products-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.product-card {\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(16px);\n  border-radius: 20px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(245, 158, 11, 0.22);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);\n}\n\n.product-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(245, 158, 11, 0.5);\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(245, 158, 11, 0.15);\n}\n\n.product-content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.product-name {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.35rem;\n  line-height: 1.3;\n}\n\n.product-description {\n  color: #cbd5e1;\n  font-size: 0.92rem;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.detail-section {\n  background: rgba(30, 41, 59, 0.5);\n  border-radius: 12px;\n  padding: 1.25rem;\n  margin-bottom: 1.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  margin-top: auto;\n}\n\n.detail-section h4 {\n  color: #ffffff;\n  font-size: 0.88rem;\n  margin-bottom: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.detail-section ul {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.detail-section li {\n  color: #94a3b8;\n  padding: 0.3rem 0 0.3rem 1.5rem;\n  position: relative;\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.detail-section li:before {\n  content: \"\\2713\";\n  position: absolute;\n  left: 0;\n  color: var(--color-amber);\n  font-weight: bold;\n}\n\n.btn-apply {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  text-align: center;\n  background: var(--grad-primary);\n  color: #0F172A;\n  padding: 0.8rem 1.25rem;\n  border-radius: 50px;\n  text-decoration: none;\n  font-weight: 800;\n  font-size: 0.92rem;\n  transition: all 0.25s ease;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  box-sizing: border-box;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n.btn-apply:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);\n}\n\n/* Process Section */\n.process-section {\n  padding: 3rem 0 4rem;\n}\n\n.process-steps {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.25rem;\n}\n\n@media (max-width: 900px) {\n  .process-steps {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 550px) {\n  .process-steps {\n    grid-template-columns: 1fr;\n  }\n}\n\n.process-step {\n  text-align: center;\n  padding: 2rem 1.25rem;\n  background: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n  transition: transform 0.25s ease, border-color 0.25s ease;\n}\n\n.process-step:hover {\n  transform: translateY(-3px);\n  border-color: rgba(245, 158, 11, 0.4);\n}\n\n.step-icon {\n  font-size: 2.2rem;\n  margin-bottom: 0.75rem;\n  line-height: 1;\n}\n\n.step-number {\n  font-size: 0.75rem;\n  color: var(--color-amber);\n  font-weight: 800;\n  margin-bottom: 0.4rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.step-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  color: #ffffff;\n}\n\n.step-description {\n  color: #94a3b8;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* CTA Section */\n.cta-section {\n  padding: 4rem 2rem;\n  background: radial-gradient(circle at 50% 30%, rgba(245, 158, 11, 0.16) 0%, rgba(15, 23, 42, 0.96) 75%);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  border-radius: 24px;\n  text-align: center;\n  margin-bottom: 4rem;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n}\n\n.cta-title {\n  font-size: clamp(1.8rem, 3.5vw, 2.5rem);\n  font-weight: 800;\n  margin-bottom: 0.85rem;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n}\n\n.cta-subtitle {\n  font-size: 1.02rem;\n  max-width: 650px;\n  margin: 0 auto 2rem;\n  color: #cbd5e1;\n  line-height: 1.6;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-cta-primary {\n  background: var(--grad-primary);\n  color: #0F172A;\n  padding: 0.85rem 2rem;\n  border-radius: 50px;\n  text-decoration: none;\n  font-weight: 800;\n  font-size: 0.95rem;\n  transition: all 0.25s ease;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);\n}\n\n.btn-cta-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.5);\n}\n\n.kubersetu-badge {\n  display: inline-block;\n  background: transparent;\n  color: var(--color-amber);\n  padding: 0.2rem 0;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  margin-bottom: 1.25rem;\n  text-transform: uppercase;\n  border: none;\n}\n\n@media (max-width: 768px) {\n  .hero-section {\n    padding: 3rem 1.25rem;\n    margin-top: 4rem;\n  }\n  .cta-section {\n    padding: 2.5rem 1.25rem;\n  }\n  .btn-cta-primary {\n    width: 100%;\n  }\n  .hero-cta-group {\n    flex-direction: column;\n    width: 100%;\n  }\n  .btn-hero,\n  .btn-hero-secondary {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
